import React from 'react';
import { Route, Switch } from 'react-router-dom';

import http from 'api/http';
import { oilAPI } from 'api/requests';

import { ROUTE } from 'constants/routing';

import NotFoundScene from 'Scenes/NotFoundScene';
import FormulaList from './List';
import FormulaApplication from './Application';
import { ROLES } from 'constants/roles';
import NotificationManager from 'dom-managers/notification';
import Button, { buttonColor, buttonType } from 'Components/Button';
import Modal from 'Components/Modal';
import { STATUS } from 'constants/index';
import Store from '../../../../registerIDBWorker';

class OilFormulatorRouter extends React.Component {
  constructor(props) {
    props.updateUserRole(ROLES.OIL_MANUFACTURER.serverName);

    super(props);
    this.state = {
      isModalOpen: false,
    };

    this.engineTypes = [];
    this.formulasList = [];
    this.listRequestInProgress = true;

    this._loadFromStore();
  }

  roleSwitch = () => {
    const { user } = this.props;
    if (user.getActiveRole() !== ROLES.OIL_MANUFACTURER.serverName) {
      user.changeMenu(ROLES.OIL_MANUFACTURER.serverName);
    }
  };

  componentDidMount() {
    const { user } = this.props;

    this.roleSwitch();

    http.get(oilAPI.engineTypes).then(({ data }) => {
      this.engineTypes = data;
      this.forceUpdate();
    });

    http.get(oilAPI.formulasList).then(({ data: list }) => {
      Store.insert(`${user.getActiveRole()}_lists`, list, user.getManufacturerCode()).then(() => {
        this.listRequestInProgress = false;
        this._loadFromStore();
      });
    });
  }

  _loadFromStore = () => {
    const { user } = this.props;

    Store.select(`${user.getActiveRole()}_lists`, user.getManufacturerCode()).then(list => {
      this.formulasList = list;
      this.forceUpdate();
    });
  };

  _openModal = () => {
    this.setState({ isModalOpen: true });
  };

  _closeModal = () => {
    this.setState({ isModalOpen: false, requestInProcess: false });
  };

  _changeStatus = (api, applicationId, applicationDataUpdateCallback) => () => {
    this.setState({ requestInProcess: true }, () => {
      http
        .patch(api(applicationId))
        .then(({ data }) => {
          if (applicationDataUpdateCallback) applicationDataUpdateCallback(data);
          else this.updateSingleListEntry(applicationId)(data);
          NotificationManager.success(1, 'The status was updated successfully.');
        })
        .finally(this._closeModal);
    });
  };

  handleChangeStatusClick = (api, applicationId, modalBody, applicationDataUpdateCallback) => () => {
    this.modalConfirmAction = this._changeStatus(api, applicationId, applicationDataUpdateCallback);
    this.modalBody = modalBody;
    this._openModal();
  };

  _handleTogglePaymentStatus = (applicationId, isPaid, applicationDataUpdateCallback) => () => {
    this.setState({ requestInProcess: true }, () => {
      http
        .patch(oilAPI.changeFormulaPaymentStatus(applicationId, !isPaid))
        .then(({ data }) => {
          if (applicationDataUpdateCallback) applicationDataUpdateCallback(data);
          else this.updateSingleListEntry(applicationId)(data);
          NotificationManager.success(1, 'The payment status was updated successfully.');
        })
        .finally(this._closeModal);
    });
  };

  handleTogglePaymentStatusClick = (applicationId, isPaid, applicationDataUpdateCallback) => () => {
    this.modalConfirmAction = this._handleTogglePaymentStatus(applicationId, isPaid, applicationDataUpdateCallback);
    this.modalBody = `Are you sure you want to mark this formulation as ${isPaid ? 'Unpaid' : 'Paid'}?`;
    this._openModal();
  };

  getAvailableActionsListBasedOnStatusAndYear = (
    applicationStatus,
    applicationYear,
    applicationId,
    applicationDataUpdateCallback,
    applicationIsPaid
  ) => {
    const { user } = this.props;
    const isInternalUser = user.isInternal();

    let availableActionsList = [
      {
        name: 'Details',
        action: () => {
          user.goTo(
            `/${user.getManufacturerCode()}/${ROLES.OIL_MANUFACTURER.nameForUrl}${
              ROLES.OIL_MANUFACTURER.listSceneUrlPostfix
            }/${applicationId}`
          );
        },
      },
    ];

    if ((isInternalUser || applicationStatus !== STATUS.APPROVED) && applicationStatus !== STATUS.DEACTIVATED)
      availableActionsList.push({
        name: 'Edit',
        action: () => {
          user.goTo(
            `/${user.getManufacturerCode()}/${ROLES.OIL_MANUFACTURER.nameForUrl}${
              ROLES.OIL_MANUFACTURER.listSceneUrlPostfix
            }/${applicationId}/edit`
          );
        },
      });

    if (isInternalUser && applicationStatus === STATUS.PENDING)
      availableActionsList.push({
        name: 'Approve',
        key: STATUS.APPROVED,
        action: this.handleChangeStatusClick(
          oilAPI.approveFormula,
          applicationId,
          'Are you sure you want to Approve this application?',
          applicationDataUpdateCallback
        ),
      });

    if (isInternalUser && applicationStatus !== STATUS.DEACTIVATED)
      availableActionsList.push({
        name: 'Deactivate',
        key: STATUS.DEACTIVATED,
        action: this.handleChangeStatusClick(
          oilAPI.deactivateFormula,
          applicationId,
          'Are you sure you want to Deactivate this application?',
          applicationDataUpdateCallback
        ),
      });

    if (isInternalUser && applicationStatus === STATUS.PENDING)
      availableActionsList.push({
        name: 'Incomplete',
        key: STATUS.INCOMPLETE,
        action: this.handleChangeStatusClick(
          oilAPI.incompleteFormula,
          applicationId,
          'Are you sure you want to mark this application as Incomplete?',
          applicationDataUpdateCallback
        ),
      });

    if (applicationStatus === STATUS.INCOMPLETE)
      availableActionsList.push({
        name: 'Submit',
        key: STATUS.PENDING,
        action: this.handleChangeStatusClick(
          oilAPI.pendFormula,
          applicationId,
          'Are you sure you want to Submit this application?',
          applicationDataUpdateCallback
        ),
      });

    if (isInternalUser)
      availableActionsList.push({
        name: applicationIsPaid ? 'Set Unpaid' : 'Set Paid',
        action: this.handleTogglePaymentStatusClick(
          applicationId,
          applicationIsPaid,
          applicationDataUpdateCallback
        ),
      });

    //TODO RollOver goes here

    return availableActionsList;
  };

  updateSingleListEntry = oldEntryId => newEntry => {
    const { user } = this.props;

    if (oldEntryId) {
      let oldEntryIndex = 0;
      this.formulasList.forEach((entry, index) => {
        if (entry.id == oldEntryId) oldEntryIndex = index;
      });
      this.formulasList.splice(oldEntryIndex, 1, newEntry);
    } else {
      this.formulasList.unshift(newEntry);
    }

    Store.insert(`${user.getActiveRole()}_lists`, this.formulasList, user.getManufacturerCode()).then(() => {
      this._loadFromStore();
    });
  };

  renderScene = Scene => {
    return ({ match }) => {
      return (
        <Scene
          user={this.props.user}
          getAvailableActionsListBasedOnStatusAndYear={this.getAvailableActionsListBasedOnStatusAndYear}
          formulasList={this.formulasList}
          listRequestInProgress={this.listRequestInProgress}
          engineTypes={this.engineTypes}
          match={match}
          updateSingleListEntry={this.updateSingleListEntry}
          manufacturerAddresses={this.props.manufacturerAddresses}
        />
      );
    };
  };

  render() {
    const { isModalOpen, requestInProcess } = this.state;
    const rootRoute = `${ROUTE.OIL_MANUFACTURER}${ROLES.OIL_MANUFACTURER.listSceneUrlPostfix}`;
    return (
      <React.Fragment>
        <Switch>
          <Route path={`${rootRoute}/:applicationId`} render={this.renderScene(FormulaApplication)} />
          <Route exact path={`${rootRoute}`} render={this.renderScene(FormulaList)} />
          <Route render={this.renderScene(NotFoundScene)} />
        </Switch>
        <Modal isOpen={isModalOpen}>
          <header className='ect-modal-header'>Confirmation</header>
          <div className='ect-modal-body'>{this.modalBody}</div>
          <footer className='ect-modal-footer'>
            <Button
              label='No'
              type={buttonType.secondary}
              color={buttonColor.gray}
              buttonClassName='_height_40 _width_160'
              onClick={this._closeModal}
            />
            <Button
              label='Yes'
              disabledWithSpinner={requestInProcess}
              buttonClassName='_height_40 _width_160'
              onClick={this.modalConfirmAction}
            />
          </footer>
        </Modal>
      </React.Fragment>
    );
  }
}

export default OilFormulatorRouter;



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/formula/index.jsx